import { useQuery } from '@tanstack/react-query';
import { getCurrentUser } from '../utils/Sessions';
import { handleResponse } from '../utils';
import AxiosInstance from '../utils/AxiosInstance';

const useDocuments = () => {
  const user = getCurrentUser();
  return useQuery({
    queryKey: ['documents', user.id],
    queryFn: async () => handleResponse(await AxiosInstance.get('/internal_api/documents/all')),
    staleTime: Infinity,
    refetchOnReconnect: false,
    refetchOnWindowFocus: false,
    placeholderData: [],
  });
};

export { useDocuments };
